import { Box, Group } from '@mantine/core';
import type { CSSProperties, ReactNode } from 'react';
import { HeightFittedStack } from '../components/data-display/HeightFittedStack';
import { EditableDisplayBar } from './EditableDisplayBar';

export const DisplayComponentBaseView = ({
    isDirty,
    form,
    handleSaveButtonClick,
    handleCancelButtonClick,
    handleResetButtonClick,
    customButtons,
    withCreateAnother,
    children,
}: {
    isDirty: boolean;
    form?: string;
    handleSaveButtonClick?: () => void;
    handleCancelButtonClick?: () => void;
    handleResetButtonClick?: () => void;
    customButtons?: ReactNode | Array<ReactNode>;
    style?: CSSProperties; // TODO use or remove
    withCreateAnother?: boolean;
    children: ReactNode | Array<ReactNode>;
}) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
            }}
        >
            <HeightFittedStack>
                <Box
                    h={'100%'}
                    style={{
                        position: 'relative',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                    }}
                >
                    {children}
                </Box>
                <Group
                    justify="flex-end"
                    gap={0}
                >
                    <EditableDisplayBar
                        isDirty={isDirty}
                        form={form}
                        handleSaveButtonClick={handleSaveButtonClick}
                        handleResetButtonClick={handleResetButtonClick}
                        handleCancelButtonClick={handleCancelButtonClick}
                        withCreateAnother={withCreateAnother}
                    />
                    <Group
                        gap="xs"
                        justify="flex-end"
                        pt="xs"
                        pr="xs"
                    >
                        {customButtons}
                    </Group>
                </Group>
            </HeightFittedStack>
        </div>
    );
};
